import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-invoices-to-be-authorised',
    templateUrl: './invoices-to-be-authorised.component.html',
    styleUrls: ['./invoices-to-be-authorised.component.scss'],
    standalone: false
})
export class InvoicesToBeAuthorisedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
